import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "redirect-to-app",
  template: "Redirecting...",
})
export class RedirectToAppComponent {
  elem: any;

  constructor(private route: ActivatedRoute) {}

  async ngOnInit() {
    this.elem = document.documentElement;
  }

  async ionViewWillEnter() {
    let queryParams: any = this.route.snapshot.queryParams;
    if (
      queryParams &&
      queryParams.code &&
      queryParams.session_state &&
      queryParams.state
    ) {
      window.location.href = `crihub://callback?code=${queryParams.code}&session_state=${queryParams.session_state}&state=${queryParams.state}`;
    }
  }
}
